/**
 * FR translations — generated by scripts/build-locale-translations.mjs.
 * Keys marked '// @en' still return the English string; run the
 * generator after a translation pass to update this file.
 */
export const fr = {
  "nav.home": "Accueil",
  "nav.about": "À propos",
  "nav.products": "Produits",
  "nav.capabilities": "Capacités",
  "nav.quality": "Qualité & Conformité",
  "nav.news": "Actualités",
  "nav.contact": "Contact",
  "header.phone": "Téléphone",
  "header.email": "E-mail",
  "header.rfq_cart": "Panier",
  "button.request_quote": "Demander un devis",
  "search.placeholder": "Recherche par n° CAS ou nom du produit",
  "language.change": "Changer de langue",
  "hero.badge": "Excellence certifiée ISO 9001:2015",
  "hero.title.leading": "Leader de",
  "hero.title.pharmaceutical": "l'innovation",
  "hero.title.innovation": "pharmaceutique",
  "hero.description": "Longshine Boi-Tech fournit des API premium, des intermédiaires pharmaceutiques et des composés vétérinaires sur les marchés mondiaux, avec une assurance qualité certifiée ISO depuis nos installations en Inde.",
  "hero.button.explore": "Explorer les produits",
  "hero.button.quote": "Demander un devis",
  "hero.stats.countries": "Pays desservis",
  "hero.stats.products": "Produits actifs",
  "hero.stats.years": "Années d'excellence",
  "categories.title": "Solutions pharmaceutiques premium",
  "categories.subtitle": "Découvrez notre gamme complète d'API, d'intermédiaires et de composés spécialisés fabriqués selon les normes internationales les plus strictes.",
  "categories.search.placeholder": "Rechercher par numéro CAS, nom de produit ou catégorie...",
  "categories.human_apis.title": "API humaines",
  "categories.human_apis.description": "Ingrédients pharmaceutiques actifs pour la thérapeutique humaine avec dossier réglementaire complet.",
  "categories.intermediates.title": "Intermédiaires",
  "categories.intermediates.description": "Intermédiaires pharmaceutiques et éléments de synthèse de haute qualité pour la fabrication de médicaments.",
  "categories.veterinary.title": "API vétérinaires",
  "categories.veterinary.description": "Composés spécialisés pour la santé animale et les applications pharmaceutiques vétérinaires.",
  "categories.products_count": "+ Produits",
  "featured.title": "Produits phares",
  "featured.subtitle": "Découvrez nos composés pharmaceutiques les plus populaires, plébiscités par les fabricants du monde entier.",
  "featured.view_all": "Voir tous les produits",
  "features.title": "Pourquoi choisir Longshine Boi-Tech",
  "features.subtitle": "Des décennies de savoir-faire pharmaceutique combinées à des technologies de procédés de dernière génération — des API et intermédiaires conformes à toutes les normes mondiales.",
  "features.iso.title": "Certifié ISO 9001:2015",
  "features.iso.description": "Système de management de la qualité reconnu à l'échelle internationale, garant d'une excellence constante dans nos procédés et produits.",
  "features.global.title": "Chaîne d'approvisionnement mondiale",
  "features.global.description": "Réseau de distribution mondial fiable au service de laboratoires pharmaceutiques dans plus de 50 pays, avec livraison dans les délais.",
  "features.compliance.title": "Conformité réglementaire",
  "features.compliance.description": "Conformité totale aux normes FDA, EMA et autres standards internationaux de fabrication pharmaceutique.",
  "features.custom.title": "Fabrication sur mesure",
  "features.custom.description": "Services CMO/CDMO flexibles pour la synthèse personnalisée, la montée en échelle et les composés pharmaceutiques spécialisés.",
  "features.team.title": "Équipe experte",
  "features.team.description": "Professionnels R&D expérimentés et experts réglementaires dédiés à des solutions pharmaceutiques innovantes.",
  "features.facilities.title": "Installations de pointe",
  "features.facilities.description": "Sites de production modernes équipés de procédés de dernière génération et de systèmes de contrôle qualité validés.",
  "cta.title": "Prêt à devenir partenaire ?",
  "cta.subtitle": "Rejoignez les centaines d'entreprises pharmaceutiques mondiales qui font confiance à Longshine Boi-Tech pour leur approvisionnement en API et intermédiaires.",
  "cta.quote_now": "Demander un devis",
  "cta.download_catalog": "Télécharger le catalogue",
  "product.cas": "CAS",
  "product.moq": "MOQ",
  "product.bulk_discount": "Remises en gros disponibles",
  "product.details": "Détails",
  "product.sds": "FDS",
  "product.add_rfq": "Ajouter au panier",
  "product.download_started": "Téléchargement démarré",
  "product.sds_downloading": "La fiche de données de sécurité de {product} est en cours de téléchargement",
  "product.download_error": "Erreur de téléchargement",
  "product.sds_error": "Impossible de télécharger la FDS de {product}. Veuillez contacter le support.",
  "product.added_rfq": "Ajouté au panier",
  "product.added_cart": "{product} a été ajouté à votre panier",
  "product.view_cart": "Voir le panier",
  "about.hero.title": "About Longshine Boi-Tech", // @en
  "about.hero.description": "Since 2009, we have been at the forefront of pharmaceutical innovation, delivering premium APIs and intermediates that meet the highest global standards while building trusted partnerships with manufacturers worldwide.", // @en
  "about.hero.years": "15+ Years of Excellence", // @en
  "about.hero.global": "Global Reach", // @en
  "about.story.title": "Our Story", // @en
  "about.story.p1": "Longshine Boi-Tech was founded in 2009 with a vision to bridge the gap between innovative pharmaceutical research and reliable global supply. Starting as a small research facility in Pune, Maharashtra, we have grown into a leading manufacturer of pharmaceutical active ingredients.", // @en
  "about.story.p2": "Our commitment to quality and regulatory compliance has enabled us to build long-term partnerships with pharmaceutical companies across six continents. Every product we manufacture undergoes rigorous testing and quality assurance to ensure it meets international pharmaceutical standards.", // @en
  "about.story.p3": "Today, Longshine Boi-Tech is recognized as a trusted supplier of premium APIs, intermediates, and veterinary compounds, with ISO 9001:2015 certification and multiple regulatory approvals including FDA DMFs and European CEPs.", // @en
  "about.journey.title": "Our Journey", // @en
  "about.journey.subtitle": "Key milestones that shaped our growth", // @en
  "about.leadership.title": "Leadership Team", // @en
  "about.leadership.subtitle": "Experienced professionals driving our success", // @en
  "about.leadership.rajesh.name": "Dr. Rajesh Kumar", // @en
  "about.leadership.rajesh.position": "CEO & Founder", // @en
  "about.leadership.rajesh.background": "Former pharmaceutical research director with 20+ years experience in API development and regulatory affairs across India and global markets.", // @en
  "about.leadership.priya.name": "Dr. Priya Sharma", // @en
  "about.leadership.priya.position": "Chief Technology Officer", // @en
  "about.leadership.priya.background": "PhD in Pharmaceutical Chemistry from IIT Mumbai, expert in process optimization and quality assurance systems with international certifications.", // @en
  "about.leadership.amit.name": "Amit Patel", // @en
  "about.leadership.amit.position": "VP of Global Sales", // @en
  "about.leadership.amit.background": "International business development leader with extensive experience in pharmaceutical supply chains and strategic partnerships across APAC and European markets.", // @en
  "about.milestone.2009": "Company founded in Pune, Maharashtra, India", // @en
  "about.milestone.2012": "ISO 9001:2015 certification achieved", // @en
  "about.milestone.2015": "First international API exports", // @en
  "about.milestone.2018": "FDA DMF submissions approved", // @en
  "about.milestone.2020": "Expanded to veterinary APIs", // @en
  "about.milestone.2023": "Serving 50+ countries globally", // @en
  "about.values.title": "Our Values", // @en
  "about.values.subtitle": "The principles that guide everything we do", // @en
  "about.values.excellence.title": "Excellence", // @en
  "about.values.excellence.description": "We pursue the highest standards in everything we do, from product quality to customer service, ensuring consistent excellence in all our operations.", // @en
  "about.values.integrity.title": "Integrity", // @en
  "about.values.integrity.description": "Transparency, honesty, and ethical business practices form the foundation of our relationships with customers, suppliers, and regulatory bodies.", // @en
  "about.values.innovation.title": "Innovation", // @en
  "about.values.innovation.description": "Continuous improvement and ongoing process research are how we keep developing better products and tighter manufacturing routes.", // @en
  "about.cta.title": "Ready to Partner with Us?", // @en
  "about.cta.subtitle": "Discover how Longshine Boi-Tech can support your pharmaceutical manufacturing needs with our premium APIs and exceptional service.", // @en
  "about.cta.products": "View Our Products", // @en
  "about.cta.contact": "Contact Our Team", // @en
  "contact.hero.title": "Contactez-nous",
  "contact.hero.description": "Prêt à collaborer ? Notre équipe mondiale d'experts pharmaceutiques est là pour répondre à vos besoins d'approvisionnement en API et intermédiaires avec un service personnalisé.",
  "contact.hero.support": "Assistance client 24/7",
  "contact.hero.presence": "Présence mondiale",
  "contact.form.title": "Envoyez-nous un message",
  "contact.form.additional": "Informations complémentaires",
  "contact.form.subtitle": "Remplissez le formulaire ci-dessous et notre équipe vous répondra sous 24 heures.",
  "contact.form.order_subtitle": "Indiquez toute exigence supplémentaire ou instruction spéciale pour votre commande.",
  "contact.form.first_name": "Prénom",
  "contact.form.last_name": "Nom",
  "contact.form.email": "Adresse e-mail",
  "contact.form.phone": "Téléphone",
  "contact.form.company": "Entreprise",
  "contact.form.country": "Pays",
  "contact.form.inquiry_type": "Type de demande",
  "contact.form.message": "Message",
  "contact.form.files": "Attach Files (Optional)", // @en
  "contact.form.upload_text": "Click to upload or drag and drop", // @en
  "contact.form.upload_formats": "Supported formats: PDF, DOC, XLS (Max 10MB)", // @en
  "contact.form.consent": "I agree to the processing of my personal data and consent to receive marketing communications from Longshine Boi-Tech. You can unsubscribe at any time.", // @en
  "contact.form.send": "Envoyer le message",
  "contact.form.submit_additional": "Soumettre les informations",
  "contact.form.placeholder.first_name": "Enter your first name", // @en
  "contact.form.placeholder.last_name": "Enter your last name", // @en
  "contact.form.placeholder.email": "Enter your email", // @en
  "contact.form.placeholder.phone": "Enter your phone number", // @en
  "contact.form.placeholder.company": "Enter your company name", // @en
  "contact.form.placeholder.country": "Select your country", // @en
  "contact.form.placeholder.message": "Please provide details about your inquiry, including specific products of interest, quantities, and any technical requirements...", // @en
  "contact.form.placeholder.message_order": "Please provide any special requirements, delivery instructions, or additional information for your order...", // @en
  "contact.quick.title": "Quick Contact", // @en
  "contact.quick.main_office": "Main Office", // @en
  "contact.quick.general": "General Inquiries", // @en
  "contact.quick.headquarters": "Headquarters", // @en
  "contact.response.title": "Response Times", // @en
  "contact.crypto.title": "Crypto Payment Support", // @en
  "contact.crypto.description": "Need help with your cryptocurrency payment? Our crypto payment specialists are available 24/7.", // @en
  "contact.crypto.support": "Get Crypto Support", // @en
  "contact.payment.complete_order": "Complete Your Order", // @en
  "contact.payment.review_items": "Review your cart items and choose your preferred payment method. We accept major cryptocurrencies for fast, secure transactions.", // @en
  "contact.payment.crypto": "Cryptocurrency", // @en
  "contact.payment.bank": "Bank Transfer", // @en
  "contact.payment.traditional": "Traditional Payment Methods", // @en
  "contact.payment.bank_desc": "For bank transfers and traditional payment methods, please contact our sales team for detailed payment instructions.", // @en
  "contact.payment.contact_sales": "Contact Sales for Payment Details", // @en
  "products.hero.human_apis": "API humaines",
  "products.hero.intermediates": "Intermédiaires pharmaceutiques",
  "products.hero.veterinary": "API vétérinaires",
  "products.hero.catalog": "Catalogue produits",
  "products.hero.human_desc": "High-quality active pharmaceutical ingredients for human medicine, manufactured to international standards with comprehensive regulatory support.", // @en
  "products.hero.intermediates_desc": "Pharmaceutical intermediates and building blocks for drug synthesis — tight purity targets and a reliable supply track record.", // @en
  "products.hero.veterinary_desc": "Specialized active ingredients for veterinary applications, ensuring animal health and well-being with proven efficacy.", // @en
  "products.hero.catalog_desc": "Discover our comprehensive range of pharmaceutical active ingredients, intermediates, and veterinary compounds manufactured to international standards.", // @en
  "products.hero.available": "+ Produits disponibles",
  "products.search.placeholder": "Recherche par n° CAS, nom de produit ou mot-clé...",
  "products.filter.by": "Filtrer par :",
  "products.filter.category": "Catégorie",
  "products.filter.availability": "Disponibilité",
  "products.filter.advanced": "Filtres avancés",
  "products.filter.export": "Exporter le catalogue",
  "products.showing": "Affichage de {count} produits",
  "products.results.all": "Tous les produits",
  "products.sort.relevance": "Pertinence",
  "products.sort.name": "Nom A-Z",
  "products.sort.category": "Catégorie",
  "products.sort.availability": "Disponibilité",
  "footer.company": "Longshine Boi-Tech Co., Ltd.",
  "footer.certified": "Excellence certifiée ISO 9001:2015",
  "footer.description": "Fabricant pharmaceutique de premier plan livrant des API, intermédiaires et composés vétérinaires premium aux marchés mondiaux, avec une qualité sans compromis.",
  "footer.products": "Produits",
  "footer.company_links": "Entreprise",
  "footer.human_apis": "API humaines",
  "footer.intermediates": "Intermédiaires",
  "footer.veterinary": "API vétérinaires",
  "footer.all_products": "Tous les produits",
  "footer.about": "À propos",
  "footer.capabilities": "Capacités",
  "footer.quality": "Qualité & Conformité",
  "footer.contact": "Contact",
  "footer.copyright": "© 2026 Longshine Boi-Tech Pvt. Ltd. Tous droits réservés.",
  "common.search": "Rechercher",
  "common.categories.all": "Toutes catégories",
  "common.categories.human": "API humaines",
  "common.categories.intermediates": "Intermédiaires",
  "common.categories.veterinary": "API vétérinaires",
  "common.availability.all": "Toutes disponibilités",
  "common.availability.in_stock": "En stock",
  "common.availability.on_demand": "Sur demande",
  "common.availability.custom": "Personnalisé",
  "common.loading": "Chargement...",
  "common.error": "Erreur",
  "common.success": "Succès",
};
